import { SurfaceSource } from '../views/surface/constants';

import { BasePaginatedParams, BasePaginatedResponse } from './pagination';

export enum SurfaceTypes {
    Custom = 'custom',
}
export enum SurfaceStatusType {
    Active = 'active',
    Inactive = 'inactive',
}

export enum SurfaceDelayBetweenMessagesUnit {
    Days = 'days',
    Minutes = 'minutes',
    Hours = 'hours',
}

export enum SurfaceTemplateComponentTypes {
    SingleLine = 'single_line_input',
    MultiLine = 'multi_line_input',
    Button = 'action_button',
    Image = 'image',
}

export type SurfacePreset = {
    id: string;
    name: string;
    description: string;
    surface_schema: TemplateComponentInternalStructure;
};

export type TemplateComponentInternalStructure =
    | TemplateComponentInternalStructureSchema
    | TemplateComponentButtonInternalStructureSchema;

export type TemplateComponentInternalStructureSchema = {
    [key: string]: {
        _internal: {
            type: SurfaceTemplateComponentTypes;
            order: number;
            fieldName: string;
        };
    };
};

export type TemplateComponentButtonInternalStructureSchema = {
    [key: string]: {
        _internal: {
            type: SurfaceTemplateComponentTypes;
            order: number;
            fieldName: string;
        };
        label: {
            _internal: {
                type: SurfaceTemplateComponentTypes.SingleLine;
            };
        };
        action: {
            _internal: {
                type: SurfaceTemplateComponentTypes.SingleLine;
            };
        };
    };
};

export interface SurfaceBaseModel {
    id: string;
    message_count: number;
    alternate_count: number;
    name: string;
    surface_type: SurfaceTypes;
    description?: string;
    status?: SurfaceStatusType;
    source: SurfaceSource;
    preview_image_data?: string;
}

export interface SurfaceModal extends SurfaceBaseModel {
    tags?: { id: string; name: string }[];
    frequency_config?: SurfaceControlsDelayMessages;
    surface_schema?: TemplateComponentInternalStructure;
    surface_template_id?: string;
}

export type PaginatedSurfacesModal = BasePaginatedResponse<SurfaceModal>;

export interface GetSurfaceQueryParams extends BasePaginatedParams {
    sort_by?: string;
    is_sorted_desc?: boolean;
    search?: string;
    audience_id?: number[];
    tag_id?: string[];
    status?: string[];
}

export interface SurfaceFilterFormikValues {
    audience_id?: string[];
    tag_id?: string[];
    status: string[];
}

export interface SurfaceControlsDelayMessages {
    delay: {
        min: {
            quantity: number;
            unit: SurfaceDelayBetweenMessagesUnit;
        };
        max: {
            quantity: number;
            unit: SurfaceDelayBetweenMessagesUnit;
        };
    };
}

export interface SurfaceCreateModel {
    name: string;
    surface_type: SurfaceTypes;
    frequency_config?: SurfaceControlsDelayMessages;
    description?: string;
    tags?: string[];
    surface_schema?: TemplateComponentInternalStructure;
    surface_template_id?: string;
}

export interface SurfaceUpdateModal {
    name?: string;
    frequency_config?: SurfaceControlsDelayMessages;
    description?: string;
    tags?: string[];
    surface_schema?: TemplateComponentInternalStructure;
    surface_template_id?: string;
}

export interface DragItem {
    index: number;
}

export enum SurfaceFormulaViewTabs {
    CONTENT = 'content',
    ALTERNATES = 'alternates',
}

export const SurfaceFormulaViewTabsData = [
    {
        key: SurfaceFormulaViewTabs.CONTENT,
        name: 'Content',
    },
    {
        key: SurfaceFormulaViewTabs.ALTERNATES,
        name: 'Alternates',
        tooltip: 'View all of the unique, sendable messages you’ve created.',
    },
];

export enum SurfaceButtonFieldLabel {
    Text = 'label',
    Action = 'action',
}

export enum SurfaceTabs {
    Surfaces = 'surfaces',
    Templates = 'templates',
}

export const SurfaceTabsData: Record<SurfaceTabs, string> = {
    [SurfaceTabs.Surfaces]: 'All surfaces',
    [SurfaceTabs.Templates]: 'Templates',
};
